/* eslint-disable no-unused-expressions */
import {
  BaSeHeading5,
  BaSeInput,
  BaSeParagraph,
  BaSeRadio,
  BaSeSmall2,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React, { useContext } from 'react';
import { EMAIL_REGEX } from '../../../../utils/validators/constants';
import Button from '../../components/button';
import { StepContext } from './context/StepContext';
import {
  AlignButton,
  Container,
  Content,
  ContentBox,
  ContentText,
  Header,
} from './johari-styled';

const cache = Sebrae.StorageUtil.inTemporaryStore();
// eslint-disable-next-line sonarjs/cognitive-complexity
export const Proximidade = ({ dataStep, name, settings }) => {
  const {
    setCurrentStep,
    validOptionSelected,
    handleAttention,
    updateStageStatus,
  } = useContext(StepContext);

  const [formState, setFormState] = React.useState({});
  const [email, setEmail] = React.useState('');
  const [saveState, setSaveState] = React.useState(false);

  React.useEffect(() => {
    const storedState = cache.getItem('@empretec:proximidade');
    const emailState = cache.getItem('@empretec:email');
    if (emailState) {
      setEmail(emailState);
    }
    if (storedState) {
      setFormState(JSON.parse(storedState));
      updateStageStatus('PROXIMIDADE');
    } else {
      const defaultState = {};
      dataStep?.questions.forEach((domain) => {
        defaultState[domain.id] = null;
      });
      setFormState(defaultState);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onValidateEmail = React.useCallback((value) => {
    return EMAIL_REGEX.test(value);
  }, []);

  const handleChangeEmail = React.useCallback((value) => {
    setEmail(value);
  }, []);

  const validateNext = React.useCallback(() => {
    if (validOptionSelected(formState)) {
      handleAttention('Campo obrigatório não informado.');
      setSaveState(true);
      return;
    }

    if (email.length > 0 && !onValidateEmail(email)) {
      handleAttention('E-mail inválido.');
      return;
    }

    updateStageStatus('PROXIMIDADE');
    setCurrentStep((prev) => prev + 1);
  }, [
    email,
    formState,
    handleAttention,
    onValidateEmail,
    setCurrentStep,
    validOptionSelected,
    updateStageStatus,
  ]);

  const handleChange = (domainId, optionId) => {
    updateStageStatus('PROXIMIDADE');

    setFormState((prevFormState) => ({
      ...prevFormState,
      [domainId]: optionId,
    }));
    setSaveState(false);
  };

  React.useEffect(() => {
    cache.setItem('@empretec:proximidade', JSON.stringify(formState));
    cache.setItem('@empretec:email', email);
  }, [formState, email]);

  return (
    <Container>
      <Header>
        <BaSeHeading5
          isBold
          color={BaSeTheme.colors.institucionais.cinzaSebrae97}
        >
          Como você me enxerga?
        </BaSeHeading5>

        <BaSeHeading5 color={BaSeTheme.colors.institucionais.cinzaSebrae75}>
          Proximidade.
        </BaSeHeading5>
      </Header>
      <Content>
        <ContentText>
          <BaSeParagraph
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            Olá, Eu {name} estou fazendo o Empretec, promovido pelo SEBRAE.
          </BaSeParagraph>
          <BaSeParagraph
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            Uma das atividades é buscar feedback sobre as 10 Características
            Empreendedoras junto a minha rede de contatos na forma que você me
            enxerga no dia a dia.
          </BaSeParagraph>
          <BaSeParagraph
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            São apenas algumas perguntas e ao respondê-las, você vai me ajudar a
            ouvir seus conselhos, estudar pontos de melhoria e descobrir
            oportunidades potenciais na vida e no trabalho.
          </BaSeParagraph>
          <BaSeParagraph
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            Você não precisa se identificar - é só responder as perguntas com a
            sua opinião sobre mim.
          </BaSeParagraph>
          <BaSeParagraph
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            Muito obrigado!
          </BaSeParagraph>
        </ContentText>
        {/* {data.domains.map((domain) => (
            <OptionJohari domain={domain} nome={data.name} />
          ))} */}
        {dataStep?.questions?.map((domain) => (
          <ContentBox>
            <BaSeParagraph
              isBold
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              {domain.description}
            </BaSeParagraph>
            {domain.options.map(({ option }) => (
              <>
                <BaSeRadio
                  key={option.id}
                  checked={formState[domain.id] === option.id}
                  onChange={() => handleChange(domain.id, option.id)}
                  color="default"
                  id={option.id}
                  label={option.description}
                  name={`domain-${domain.id}`}
                  size="small"
                />
              </>
            ))}
            {saveState && (
              <BaSeSmall2 color={BaSeTheme.colors.feedbackInterface.erro45}>
                Campo obrigatório.
              </BaSeSmall2>
            )}
          </ContentBox>
        ))}
        <ContentBox>
          <BaSeParagraph
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            Por favor informe seu e-mail caso se sinta disponível e confortável
            para uma conversa futura sobre suas respostas nesse formulário.
          </BaSeParagraph>
          <BaSeInput
            label="E-mail:"
            subLabel="Opcional"
            placeholder="Insira um e-mail"
            typeInput="email"
            inputMode="email"
            value={email}
            onChange={handleChangeEmail}
            inputStatus={
              onValidateEmail(email)
                ? 'valid'
                : email === ''
                ? 'normal'
                : 'invalid'
            }
          />
        </ContentBox>
      </Content>
      <AlignButton>
        <Button
          calback={() => validateNext()}
          value={'AVANÇAR'}
          valueSmall={'AVANÇAR'}
          withBorder={true}
          color={settings?.tertiaryColor}
          borderColor={settings?.primaryColor}
        />
      </AlignButton>
    </Container>
  );
};
